<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getRating, getRatableProducts, submitRating } from "../../api"
    import { langField } from "../../i18n"
    import FormInputText from "../widgets/Form/FormInputText.svelte"
    import Index from "../SEO/Index.svelte"
    import { spaNavigate } from "../../functionTools/navigation"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { withImageCacheBuster } from "../../utils"
    let { params } = $props()

    let loading = false
    let orderRating: { cart: CartItem[]; orderId: string } = $state()
    let validateOrderForm = $state({
        orderNumber: "",
        postHeadNumber: "",
    })

    let ratingForm: OrderRating[] = $state([])
    let originalRatings: OrderRating[] = []
    let alreadyRated: any = {}

    function removeDuplicateObjects(array: any[]) {
        const seen: { [key: string]: boolean } = {}
        let filteredArray = array.filter((item) => {
            if (!seen[item.product.id]) {
                seen[item.product.id] = true
                return true
            }
            return false
        })

        return filteredArray
    }
    let showgotSaved: boolean[] = $state([])

    const createRatingForm = async (orderNumber: string, postHeadNumber: string) => {
        const { data: ratings } = await getRating(orderNumber, postHeadNumber)
        const ratedProducts = ratings.reduce((acc, item) => ({ ...acc, [item.productId]: item }), {})
        alreadyRated = ratedProducts
        let { cart, id } = await getRatableProducts(orderNumber, postHeadNumber)

        cart = removeDuplicateObjects(cart)
        orderRating = { cart, orderId: id }

        ratingForm = cart.map((item) => {
            // @ts-ignore
            if (ratedProducts[item.product.id]) {
                return {
                    // @ts-ignore
                    ...ratedProducts[item.product.id],
                    usePutForRating: true,
                }
            } else {
                return {
                    orderId: orderRating.orderId,
                    rating: 0,
                    comment: "",
                    author: "",
                    usePutForRating: false,
                    status: "pending",
                    review_date: new Date(),
                    productId: item.product.id,
                }
            }
        })
        showgotSaved.map((item) => false)
        originalRatings = JSON.parse(JSON.stringify(ratingForm))

        return ratingForm
    }

    function hasRatingChanged(index: number) {
        return (
            ratingForm[index].rating !== originalRatings[index].rating ||
            ratingForm[index].comment !== originalRatings[index].comment ||
            ratingForm[index].author !== originalRatings[index].author
        )
    }

    const submitOrderForm = async () => {
        spaNavigate(`/order/rating/${validateOrderForm.orderNumber}/${validateOrderForm.postHeadNumber}`)
        try {
            ratingForm = await createRatingForm(validateOrderForm.orderNumber, validateOrderForm.postHeadNumber)
        } catch (e) {
            alert($_("my-orders.not-found"))
        }
    }

    if (params) {
        let orderSequence = params.split("/")[0]
        let postalCode = params.split("/")[1]
        if (orderSequence && postalCode) {
            validateOrderForm.orderNumber = orderSequence
            validateOrderForm.postHeadNumber = postalCode
            submitOrderForm()
        }
    }

    const submitRatingForm = (i: number) => {
        let ratingObj: OrderRating = {
            orderId: orderRating.orderId,
            ...ratingForm[i],
        }
        if (!ratingForm[i].rating) {
            alert($_("ratings.giveRatingError"))
            return
        }

        if (!ratingObj.author) ratingObj.author = "Anonym"

        submitRating(ratingObj).then((res) => {
            ratingForm[i].usePutForRating = true
            ratingForm[i].id = res.id

            showgotSaved[i] = true
            setTimeout(() => {
                showgotSaved[i] = false
            }, 2000)
            originalRatings[i] = JSON.parse(JSON.stringify(ratingObj))
            if (typeof window !== "undefined") {
                window.localStorage.setItem(ratingObj.productId, JSON.stringify(ratingObj))
            }
        })
    }

    const alreadyPublished = (item: CartItem) => {
        if (Object.keys(alreadyRated).includes(item.product.id))
            return alreadyRated[item.product.id].status != "pending"

        return false
    }
</script>

<Index noIndex={true} title={$_("my-orders.rate-order")} metaDescription={$_("meta.description")} />
<section class="section-type-1 section_padding">
    <div class="container">
        <h1>
            {$_("my-orders.rate-order")}
        </h1>
        {#if !ratingForm.length}
            <form
                class="orderform"
                onsubmit={(e) => {
                    e.preventDefault()
                    submitOrderForm()
                }}
            >
                <div class="row">
                    <div class="col-md-6">
                        <FormInputText
                            name="order-number"
                            label={$_("my-orders.order-number")}
                            required
                            type="number"
                            bind:value={validateOrderForm.orderNumber}
                        />
                    </div>
                    <div class="col-md-6">
                        <FormInputText
                            name="postcode"
                            label={$_("my-orders.postcode")}
                            required
                            bind:value={validateOrderForm.postHeadNumber}
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        {#if loading}
                            <BarLoader />
                        {:else}
                            <button type="submit" class="button primary">{$_("my-orders.send")}</button>
                        {/if}
                    </div>
                </div>
            </form>
        {:else}
            <div class="articles">
                {orderRating.cart.filter((el) => !el._parent_uuid).length}
                {$_("ratings.articles")}
            </div>
            <div class="ratable-products">
                {#each orderRating.cart.filter((el) => !el._parent_uuid) as item, i}
                    <div class="row" class:already-published={alreadyPublished(item)}>
                        <div class="img">
                            <img
                                src={item.product.images?.[0]?.file?.src
                                    ? withImageCacheBuster(item.product.images[0].file.src)
                                    : "/media/kein-bild.jpg"}
                                alt="product"
                                loading="lazy"
                            />
                        </div>

                        <form
                            class="rating-form"
                            onsubmit={(e) => {
                                e.preventDefault()
                                submitRatingForm(i)
                            }}
                        >
                            <div class="product-name">
                                {langField(item.product.name, "")}
                            </div>
                            <div class="artnr">
                                {$_("product.item-number-short")}
                                {item.product.base_code}
                            </div>
                            <div class="stars">
                                {#each Array.from({ length: 5 }, (v, k) => k) as star}
                                    <label class="star-container">
                                        <input
                                            disabled={alreadyPublished(item)}
                                            type="checkbox"
                                            class="star-checkbox"
                                            value={star}
                                            onchange={() => {
                                                ratingForm[i].rating = star + 1
                                            }}
                                        />
                                        <svg
                                            class:filled={ratingForm[i].rating > star}
                                            class="star"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M18.75 8.125h-6.719L10 1.875l-2.031 6.25H1.25l5.469 3.75-2.11 6.25L10 14.219l5.39 3.906-2.109-6.25 5.469-3.75z"
                                                stroke="#464646"
                                                stroke-linejoin="round"
                                            ></path>
                                        </svg>
                                    </label>
                                {/each}
                            </div>
                            <FormInputText
                                fullWidth={true}
                                name="ratingsname"
                                label="Name"
                                disabled={alreadyPublished(item)}
                                opacity={alreadyPublished(item)}
                                bind:value={ratingForm[i].author}
                            />

                            <div class="inputholder display-none"></div>
                            <label for="rating-comment-{i}" class="sr-only">{$_("ratings.rating-textarea")}</label>
                            <textarea
                                id="rating-comment-{i}"
                                placeholder={$_("ratings.rating-textarea")}
                                disabled={alreadyPublished(item)}
                                bind:value={ratingForm[i].comment}
                            ></textarea>
                            {#if ratingForm[i].usePutForRating && !alreadyPublished(item)}
                                <div class="in-process">{$_("ratings.processed")}</div>
                            {/if}
                            {#key ratingForm[i]}
                                <button
                                    type="submit"
                                    disabled={!hasRatingChanged(i)}
                                    class="button primary not-published">{$_("ratings.save")}</button
                                >
                                {#if showgotSaved[i]}
                                    <div class="got-saved">{$_("ratings.saved")}</div>
                                {/if}
                            {/key}

                            <button disabled class="published-button button">{$_("ratings.already-published")}</button>
                        </form>
                    </div>
                {/each}
            </div>
        {/if}
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
    .display-none {
        display: none;
    }
    .published-button {
        display: none;
    }
    .got-saved {
        color: var(--primary);
        font-size: 0.7rem;
    }
    .in-process {
        color: var(--on-background);
        font-size: 0.7rem;
    }
    .already-published {
        .not-published {
            display: none;
        }
        .published-button {
            color: white;
            background-color: var(--on-surface-2);
            display: block;
        }
        textarea,
        input,
        div {
            opacity: 0.5 !important;
        }
        .button {
            opacity: 1;
        }
    }
    .container {
        max-width: 1230px;
    }
    .articles {
        font-size: 1.8rem;
        margin-bottom: 20px;
        @media @tablet {
            margin-bottom: 40px;
        }
    }
    .star-checkbox {
        display: none;
    }

    .star-container {
        display: inline-block;
        cursor: pointer;
    }

    .ratable-products {
        display: flex;
        flex-direction: column;
        gap: 20px;
        @media @tablet {
            gap: 40px;
        }
        .row {
            margin: 0px;
            padding-bottom: 40px !important;
            border-bottom: 1px dotted #c7c7c7;
            flex-direction: column;
            padding: 15px;
            padding-bottom: 20px;
            gap: 20px;
            @media @tablet {
                padding: 0px;
                padding-bottom: 40px;
                flex-direction: row;
                gap: 40px;
            }
            flex-wrap: nowrap;

            .img {
                display: flex;
                align-items: center;
                img {
                    height: 100%;
                }
            }

            form {
                height: 100%;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .product-name {
                    font-size: 1.5rem;
                }
                .artnr {
                    font-size: 0.75rem;
                    margin-bottom: 20px;
                }

                .stars {
                    display: flex;
                    gap: 5px;
                    margin-bottom: 20px;
                    height: 20px;

                    .star {
                        height: 20px;
                        background-color: transparent;
                        border: 0px solid black;
                        padding: 0px;
                        cursor: pointer;
                        &.filled path {
                            stroke: var(--primary);
                            fill: var(--primary);
                        }
                    }
                }
                textarea {
                    padding: 10px 20px;
                    height: 170px;
                    width: 100%;
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>
